<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <div class="sub-buttonGroup">
                <el-button v-if="subformCreate"
                    @click.stop="newItem"
                    size="default"
                    type="primary">
                    + {{ newName }}
                </el-button>
                
                <el-popconfirm class="sub-upload" title="是否追加导入？"
                    @cancel="beforeUpload(false)"
                    @confirm="beforeUpload(true)"
                    confirm-button-text="追加"
                    cancel-button-text="覆盖">
                    <template #reference>
                    <el-button size="default" plain>
                        <el-icon><download /></el-icon>{{ excelName }}
                    </el-button>
                    </template>
                </el-popconfirm>

                <input hidden="hidden" :name="uploadId" @change="importByExcel" type="file" accept=".xls,.xlsx,.csv" />
                <input hidden="hidden" :name="fieldName" :value="valueString" />
                <el-button class="sub-delete"
                    v-if="subformDelete" 
                    size="default"
                    :disabled="selectItemIds.length === 0"
                    @click.stop="allDelete"
                    plain>
                    <el-icon><delete /></el-icon>
                    {{ batchDeleteName }}
                </el-button>
            </div>
            
            <el-table ref="table"
                :show-summary="showSummary"
                :summary-method="getSummaries"
                :data="showTableData"
                min-height="400"
                max-height="500"
                style="width: 100%"
                @cell-click="clieckCell"
                @selection-change="handleSelectionChange">
                    <el-table-column v-if="subformDelete"
                        type="selection"
                        fixed
                        width="47">
                    </el-table-column>
                    <el-table-column
                        label="序号"
                        type="index"
                        fixed
                        width="60"> 
                    </el-table-column>
                    <el-table-column 
                        v-for="item in gridDefinition"
                        :key="item.Name"
                        show-overflow-tooltip
                        min-width="200"
                        :formatter="(row, column, cellValue, index)=> formatter(item.FieldDefinition.Name, row, column, cellValue, index)"
                        :prop = "item.Name"
                        :label = "item.Settings.ContentPartFieldSettings.DisplayName">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        v-if = "!disabled && !isInlineEdit">
                        <template #default="scope">
                            <el-button @click.native.prevent="editRow(scope.row.QweGuid)"
                                    link
                                    type="primary"
                                    size="small">
                                    编辑
                            </el-button>
                        </template>
                </el-table-column>
            </el-table>
            
            <el-pagination v-if="!showAll"
                v-model:currentPage="currentpage"
                v-model:page-size="pagesize"
                :page-sizes="[20,50]"
                :background="true"
                layout="total, sizes, prev, pager, next, jumper"
                :total="(data[name] || []).length" >
            </el-pagination>
            <el-dialog
                width="70%"
                top="0"
                class="qweFormDialog"
                lock-scroll
                :title="displayName"
                append-to-body 
                :close-on-click-modal="false"
                v-model="dialogVisible"
                :destroy-on-close="true">
                <qweForm @Submit="updateSubmitForm"
                    isPropMode
                    :propDatas="propDatas"
                    :is-show-head="false"></qweForm>
            </el-dialog>

            <div v-if="inlineEditRowVisible">
                <Teleport :to="'#' + inlineEditRowId">
                    <tr class="el-table__row inline_edit_row"
                        @click.stop="stopEditRowClick"
                        :style="eidtRowStyle">
                        <td v-if="subformDelete" class="el-table_2_column_14 el-table-column--selection el-table-fixed-column--left el-table__cell" 
                            rowspan="1" colspan="1" style="left: 0px;">
                            <div class="cell"><!---->
                                <label class="el-checkbox el-checkbox--large is-disabled">
                                    <span class="el-checkbox__input is-disabled">
                                        <input class="el-checkbox__original" type="checkbox" disabled>
                                        <span class="el-checkbox__inner"></span>
                                    </span><!--v-if-->
                                </label>
                            </div>
                        </td>
                        <td class="el-table_2_column_15 el-table-fixed-column--left is-last-column el-table__cell" 
                            rowspan="1" colspan="1" style="width:60px" :class="{'is-float-47': subformDelete}">
                            <div class="cell">
                                <div>{{ editRowIndex }}</div>
                            </div>
                        </td>
                        <td :colspan="gridDefinition.length">
                            <inlineForm ref="inlineForm"
                                @setParentValue="inlineSubmit"
                                isPropMode
                                :propDatas="propDatas"
                                :is-show-head="false"></inlineForm>
                        </td>
                    </tr>
                </Teleport>
            </div>
        </el-form-item>
    </el-col>
</template>

<style>
    .sub-delete{
        margin-left: 12px;
    } 

    .inlineEditTable td{
        cursor: pointer;
    }

    .inline_edit_row{
        position: absolute;
        top: var(--top);
        height: var(--height);
        z-index: 1;
        border-bottom: 1px solid #ebeef5;
    }

    .inline_edit_row td.el-table__cell{
        border-bottom: 0px;
    }

    .is-float-47{
        left: 47px;
    }
</style>

<script>
    import baseSubFormField from "./BaseSubFormField"
    import { InfoFilled, Download, Delete } from '@element-plus/icons-vue'
    import FormItemVue from "../../Form/FormItem.vue"
    import ininleFormItem from "../../Form/TableInlineFormItem.vue"
    import { qweLetterGuid } from "../../../common/commonHelper"

    export default {
        name:"SubFormField",
        mixins:[baseSubFormField],
        components:{
            "download": Download,
            "info-filled":InfoFilled,
            "delete":Delete,
            "qweForm":FormItemVue,
            "inlineForm":ininleFormItem
        },

        data:function(){
            return {
                currentRowGuid: "",
                inlineEditRowVisible: false,
                inlineEditRowId:"",
                eidtRowStyle: "--height:0px;--top:0px",
                editRowIndex:1,
                editRowContentDefinition:[],
                editRowFlowDefinition:[]
            }
        },

        created:function(){
            if(this.isInlineEdit){ 
                this.editRowFlowDefinition = JSON.parse(JSON.stringify(this.originalFlowDefinition));

                this.editRowFlowDefinition.forEach(x=>{
                    x.IsDisplay = false
                });

                this.gridDefinition.forEach(x=>{
                    let findIndex = this.editRowFlowDefinition.findIndex(flow => flow.Name == x.Name);
                    if(findIndex > -1){
                        this.editRowFlowDefinition[findIndex].IsDisplay = true;
                    }
                });

                let gridFields = this.selfSetting.GridFields || []; 
                this.editRowContentDefinition = JSON.parse(this.selfSetting.FieldsString);

                this.editRowContentDefinition.sort((prev, next) => {
                    const p = gridFields.indexOf(prev.Name)
                    const n = gridFields.indexOf(next.Name)
                    return p - n
                })
            }
        },

        mounted:function(){
            if(this.isInlineEdit && !this.disabled){
                this.inlineEditRowId = qweLetterGuid(); 
                let tableElement = this.$el.querySelector(".el-table__body");
                let tableBody = tableElement.querySelector("tbody"); 
                tableBody.setAttribute("style", "position:relative");
                tableBody.setAttribute("class", "inlineEditTable");
                tableBody.setAttribute("id", this.inlineEditRowId);
                document.addEventListener("click", this.tableOutClick);
            }
        },

        beforeUnmount:function(){
            document.removeEventListener("click", this.tableOutClick);
        },

        computed:{
            widthMap:function(){
                let widthMap = {};
                let columns = this.$refs.table.store.states.columns.value;
                let lastIndex = columns.length -1;
                columns.forEach((element,index) => {
                    if(index == lastIndex){
                        widthMap[element.property] = (element.width ?? element.realWidth) - 10;
                    }
                    else{
                        widthMap[element.property] = element.width ?? element.realWidth 
                    }
                });
                return widthMap;
            }
        },

        methods:{
            tableOutClick:function(e){
                this.inlineEditRowVisible = false;
            },

            clieckCell: function(row, column, cell, event){
                event.stopPropagation();
                if(this.disabled){
                    return;
                }
                if(!this.isInlineEdit){
                    return;
                }

                if(this.inlineEditRowVisible){
                    this.$refs.inlineForm.initData(row);
                    let index = (this.data[this.name] ||[]).findIndex(x=>x.QweGuid == row.QweGuid);
                    this.editRowIndex = index + 1;
                    this.currentRowGuid = row.QweGuid; 
                    let parentRow = $(cell.parentElement)[0];
                    this.eidtRowStyle = `--height:${parentRow.clientHeight}px;--top:${parentRow.offsetTop}px`;
                }
                else{
                    this.showInlineEditRow(row, cell);
                }
            },

            showInlineEditRow:function(row, cell){
                let index = (this.data[this.name] ||[]).findIndex(x=>x.QweGuid == row.QweGuid);
                this.editRowIndex = index + 1;
                this.currentRowGuid = row.QweGuid; 

                let parentRow = $(cell.parentElement)[0];
                this.eidtRowStyle = `--height:${parentRow.clientHeight}px;--top:${parentRow.offsetTop}px`;
                
                this.propDatas.FlowDefinition = this.editRowFlowDefinition;
                this.propDatas.ContentTypeDefinition = this.editRowContentDefinition;
                this.propDatas.Data = row;
                this.propDatas.WidthMap = this.widthMap;
                this.inlineEditRowVisible = true;
            },

            inlineSubmit:function(data){
                let parentDataIndex = (this.data[this.name] || []).findIndex(x=>x.QweGuid == data.guid);
                this.OriginalDefinition.forEach(x=>{
                    (this.data[this.name] || [])[parentDataIndex][x.Name] = data.formData[x.Name];
                })
            },

            stopEditRowClick:function(){
                
            }
        }
    }
</script>